import React, { useEffect, useState } from 'react';
import { AsyncLoader } from 'Components/widgets/loading/async-loader/AsyncLoader';
import { t } from 'Src/i18n';
import { computePriceInCents } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useUplift } from './useUplift';
import { UpliftPrice } from './UpliftPrice';
type Props = {
  isPaymentPage: boolean;
  proposal: Proposal;
  price: any;
  iconClassname: string;
};
export const UpliftFromPricing = ({ isPaymentPage, proposal, price, iconClassname }: Props) => {
  const [isLoaded, setIsLoaded] = useState(null);
  const booking = {
    arrivalDate: proposal.departureDate,
    departureDate: proposal.arrivalDate,
    name: proposal.productId,
    accommodationsCount: proposal.accommodationsCount,
    attendees: [],
    price: price.total.value,
  };
  useUplift({
    onLoaded: setIsLoaded,
    currency: proposal.price.currency,
    booking,
    isPaymentPage,
    shouldInit: !isPaymentPage,
  });
  useEffect(() => {
    setIsLoaded(isPaymentPage ? true : null);
  }, [isPaymentPage]);
  const isLoading = isLoaded === null;
  return (
    <div className="flex text-center lg:justify-center">
      {isLoading && <AsyncLoader size="small" />}
      <span
        className={classnames('text-normal hidden font-sans text-14 lg:text-center', {
          ['!hidden']: isLoading,
        })}
        data-up-price-value={computePriceInCents(price.total.value)}
        data-up-price-type="total"
      >
        <span>{t('booking.banking.paymentSchedule.fromPricing')} </span>
        <UpliftPrice currency={proposal.price.currency} iconClassname={iconClassname} />
      </span>
    </div>
  );
};
